import icon from 'vue-svgicon';

icon.register({
    'regular/car-repair-fluid': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.25 9.75l-3-3H3.75L1.811 8.689A3.624 3.624 0 0 0 .75 11.25a1.5 1.5 0 0 0 1.5 1.5h12M1.075 9.75H5.25M3.75 6.75l1.7-4.54A2.249 2.249 0 0 1 7.559.75h8.882a2.249 2.249 0 0 1 2.106 1.46l1.7 4.54zM2.25 12.75v1.5a1.5 1.5 0 0 0 3 0v-1.5z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M23.25 19.5a3.75 3.75 0 0 1-7.5 0c0-2.071 3.75-9 3.75-9s3.75 6.929 3.75 9zM18.75 18.75v1.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
